import angular from 'angular';
import CSMCommonWeb from 'csm-common-web';

export default angular
  .module('csm.books.events', [CSMCommonWeb])
  .service('Events', eventsService)
  .name;
  
/*****************************************************************************
 * Service: Events */
/**
 * @ngdoc     service
 * @module    csm.books.eventsAdmin
 * @name      csm.books.eventsAdmin.service:Events
 * @description
 * Handles communication with server.
 *****************************************************************************/
/* @ngInject */ function eventsService(HTTPService) {
  var http = HTTPService.make('/books/eventsAdmin/');

  this.addGuest = (id, guest) =>
    http.post('addGuest', { id: id, guest: guest });
  this.allowTickets = () => http.get('allowTickets');
  this.drop = (id) => http.post('drop', id);
  this.dropAttendee = (attendeeID, eventID) =>
    http.post('dropAttendee', { attendeeID: attendeeID, eventID: eventID });
  this.endEvent = (eventID, unend) =>
    http.post('endEvent', { eventID: eventID, unend: unend });
  this.get = (id) => http.post('get', id);
  this.getAttendees = (eventID) => http.post('getAttendees', eventID);
  this.getList = () => http.get('getList');
  this.getProductList = () => http.get('getProductList');
  this.reset = (id) => http.post('reset', id);
  this.save = (event) => http.post('save', event);
  this.saveAttendee = (attendee) => http.post('saveAttendee', attendee);
  this.saveAttendees = (attendees) => http.post('saveAttendees', attendees);
}
